import { useLocation, useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { Organization } from '@/components/compliance-assistant/layout/Organization'
import { UnholsterLogo } from '@/components/compliance-assistant/layout/UnholsterLogo'
import { User } from '@/components/compliance-assistant/layout/User'

const selectedStyle = (pathname: string, path: string) => {
  return pathname.startsWith(path) ? '| bg-black | text-white' : ''
}

function Sidebar() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  return (
    <div className="h-screen | flex | flex-col | w-full | min-h-full | items-center | justify-between | border-r | border-gray-200">
      <div className="flex | flex-col | w-full">
        <div className="flex | w-full | items-center | justify-between | gap-2 | p-4">
          <Organization />
          <User />
        </div>
        <div className="flex | flex-col | gap-1 | p-2">
          <Button
            className={`p-ui | w-full | justify-start ${selectedStyle(
              pathname,
              '/procesamientos'
            )}`}
            onClick={() => navigate('/procesamientos')}
            variant={pathname.startsWith('/procesamientos') ? 'default' : 'ghost'}
          >
            Procesamientos
          </Button>
          {<Button
            className={`p-ui | w-full | justify-start ${selectedStyle(pathname, '/graph')}`}
            onClick={() => navigate('/graph')}
            variant={pathname.startsWith('/graph') ? 'default' : 'ghost'}
          >
            Mallas
          </Button>}
        </div>
      </div>
      <UnholsterLogo />
    </div>
  )
}

export { Sidebar }
